/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import type { TTooltipSide } from 'volta/components/bv-tooltip';
import type { TSize } from 'volta/utils/style-utils';

const SIZES = new Set(['sm', 'md', 'lg', 'xs', 'xl', 'xxl']);

interface BvAvatarSignature {
  Args: {
    firstName?: string;
    lastName?: string;
    login?: string;
    isFocus?: boolean;
    isActive?: boolean;
    isDisabled?: boolean;
    tooltip?: string;
    tooltipSide?: TTooltipSide;
    size?: TSize;
    presence?: 'online' | 'inactive' | 'offline';
    background?: string;
    img?: string;
    onClick?: (e: MouseEvent) => void;
  };
  Element: HTMLSpanElement;
}

export default class BvAvatarComponent extends Component<BvAvatarSignature> {
  // Properties
  // ~~~~~
  @tracked isFocus: boolean = this.args.isFocus ?? false;

  get initials() {
    const { firstName, lastName, login } = this.args;
    if (firstName && lastName) {
      return `${(firstName[0] ?? '').toUpperCase()}${(lastName[0] ?? '').toUpperCase()}`;
    }
    return login && login.slice(0, 2).toUpperCase();
  }

  get sizeClass() {
    const { size = 'md' } = this.args;
    return (size && SIZES.has(size) && `bv-avatar--${size}`) || '';
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    BvAvatar: typeof BvAvatarComponent;
    'bv-avatar': typeof BvAvatarComponent;
  }
}
